import { Spinner } from '@serodigital/ui-components';
import { SeroProps } from '@serodigital/ui-components/dist/types/SeroProps';
import * as React from 'react';

export type SummaryIconType = 'total' | 'offline' | 'online' | 'unhealthy';

interface ISummaryCardProps extends SeroProps {
  icon: SummaryIconType;
  value: number;
  title: string;
}

type IconLookup = { [icon: string]: any };
const icons: IconLookup = {
  total: require('../../assets/images/summaryCards/bees-total.png'),
  offline: require('../../assets/images/summaryCards/bees-offline.png'),
  online: require('../../assets/images/summaryCards/bees-online.png'),
  unhealthy: require('../../assets/images/summaryCards/bees-unhealthy.png'),
};

const classNames = [
  'flex',
  'flex-col',
  'flex-grow',
  'sero-bg-white',
  'min-h-160',
  'flex-auto',
  'w-[300px]',
  'border',
  'border-[#CED4D1]',
  'rounded-xl',
  'justify-center',
  'mx-[10px]',
  'my-12',
  'py-24',
  'grow',
];

export function SummaryCard({
  icon,
  title,
  value = 0,
  'data-qa': dataQa = `summary-card-${title}`,
}: ISummaryCardProps) {
  return (
    <div data-qa={dataQa} className={classNames.join(' ')}>
      <div className="flex flex-row flex-wrap shrink justify-center items-center" data-qa={`${dataQa}-details`}>
        <img className="w-40 h-40 mx-[6px]" src={icons[icon]} alt={title} data-qa={`${dataQa}-icon`} />
        <p className="text-[1.25rem] text-center text-wrap mx-[6px]">{title}</p>
      </div>
      <div className="mx-4">
        <p className="text-[3.75rem] text-center">{value}</p>
      </div>
    </div>
  );
}
